var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_AddCharges"),
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { height: "350px", padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "1001001",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toAdd } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "danger" }, on: { click: _vm.toRemove } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remove")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toChangeSchema }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ChangeSchema")))]
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "font-weight": "bold",
                        color: "#409EFF"
                      }
                    },
                    [
                      _vm.chargeType === 0 || _vm.chargeType === 1
                        ? [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_Receivable")) +
                                  "："
                              )
                            ]),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.arTotalDisplay)
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm.chargeType === 0 || _vm.chargeType === 2
                        ? [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Dues")) + "："
                                )
                              ]
                            ),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.apTotalDisplay)
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toSave } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c("el-button", { on: { click: _vm.toCancel } }, [
                    _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
                  ])
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }